import storageService, { StorageServiceInterface, StorageType } from 'src/services/storage-service';
import { RoutesConfig } from '../state/routesSlice';

export enum StorageKeys {
    CURRENT_ROUTES_CONFIG = 'routes.routesConfig',
}

const localStorageOptions = {
    storage: StorageType.SESSION_STORAGE,
};

export class RoutesStorageService {
    private storageService: StorageServiceInterface;

    public constructor(storageService: StorageServiceInterface) {
        this.storageService = storageService;
    }

    public getCurrentRoutesConfig(): RoutesConfig | null {
        return this.storageService.get(StorageKeys.CURRENT_ROUTES_CONFIG, localStorageOptions);
    }

    public setCurrentRoutesConfig(routesConfig: RoutesConfig): void {
        this.storageService.remove(StorageKeys.CURRENT_ROUTES_CONFIG);

        this.storageService.save(StorageKeys.CURRENT_ROUTES_CONFIG, routesConfig, localStorageOptions);
    }

    public clearAll(): void {
        this.storageService.remove(StorageKeys.CURRENT_ROUTES_CONFIG, localStorageOptions);
    }
}

export default new RoutesStorageService(storageService);
